module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_0.c82da247.png";